import { render, staticRenderFns } from "./WorkRulesForm.vue?vue&type=template&id=92bd712c&"
import script from "./WorkRulesForm.vue?vue&type=script&lang=js&"
export * from "./WorkRulesForm.vue?vue&type=script&lang=js&"
import style0 from "./WorkRulesForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports